<script>
    import Header from "../components/Header.svelte";
    import Footer from "../components/Footer.svelte";

    export let identity = {};
    export let params = {};
    export let showMenu = !params.isGuest;

    export let totalAnalyzes = 0;

    export let currentUrl;

    export let language;
</script>

<div class="layout-wrap default-layout">
        <Header params={params} {showMenu} {identity} {totalAnalyzes} {language} />

        <div class="content-wrap">
            <slot name="content">
                <span>Loading...</span>
            </slot>
        </div>

        <Footer {params} {language} />
</div>

<style>
    @media screen and (min-width: 1114px) {
        .content-wrap {
            min-height: calc(100vh - 128px - 60px);
        }
    }
    @media screen and (max-width: 1113px) {
        .content-wrap {
            min-height: calc(100vh - 230px - 60px);
        }
    }
</style>